var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "roomConItem" }, [
    _vm.item.items.length
      ? _c(
          "div",
          {
            key: _vm.index,
            staticClass: "room room_default skin-card",
            class: [
              "rank" + _vm.index,
              "rarity--" +
                (_vm.$screen.mobile ? "best" : _vm.item.items[0].rarity),
            ],
            on: {
              click: function ($event) {
                return _vm.$router.push({
                  name: "rollDetail",
                  params: { id: _vm.item.id },
                })
              },
            },
          },
          [
            _c("div", { staticClass: "item-con" }, [
              _c("div", { staticClass: "item-pic" }, [
                _c("img", {
                  attrs: {
                    src: _vm._f("imgfilter")(_vm.item.items[0].itemPic),
                  },
                }),
              ]),
              _c("div", { staticClass: "dur" }, [
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("GetItemDuration")(_vm.item.items[0].name)
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "price" }, [
                _vm._v(_vm._s(_vm.item.items[0].price)),
              ]),
            ]),
            _c("div", { staticClass: "room-info" }, [
              _c("div", { staticStyle: { width: "100%" } }, [
                _c(
                  "p",
                  {
                    staticClass: "title skin-card_title",
                    staticStyle: { "font-size": "18px" },
                  },
                  [_vm._v(" " + _vm._s(_vm.item.name) + " ")]
                ),
                _c("div", { staticClass: "item-name-con" }, [
                  _c("div", { staticClass: "weapon-name" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("GetItemName")(_vm.item.items[0].name)) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "line" }),
                  _c("div", { staticClass: "skin-name" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("GetItemSkinName")(_vm.item.items[0].name)
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "room-desc" }, [
                  _vm._v("点击参与或了解条款和条件"),
                ]),
              ]),
              _c("div", { staticClass: "time-con" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../assets/icons/clock.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "time" }, [
                  _vm._v(_vm._s(_vm._f("timeToCounter")(_vm.item.expir_time))),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "join-con" },
              [_c("font", [_vm._v(_vm._s(_vm.item.userCount))]), _vm._m(0)],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sc-bczRLJ jdEvYF" }, [
      _c("img", {
        attrs: {
          src: require("../../../../assets/icons/jiangbei.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }